const GenderList = [
  {
    Code: 'M',
    Code2: 2,
    NameES: 'Mujer',
    NameEN: 'Female',
  },
  {
    Code: 'H',
    Code2: 1,
    NameES: 'Hombre',
    NameEN: 'Male',
  },
];

export default GenderList;
